module.exports = __webpack_public_path__ + "img/潭柘寺.3a4b3b6b.png";